import { Button, HStack } from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

interface Option {
  value: string;
  label: string;
}

type ButtonType = 'button' | 'submit' | 'reset';

export interface ButtonListFieldProps {
  id?: string;
  options: Option[];
  onClick?: any;
  name: string;
  btnType?: ButtonType;
  isDisabled?: boolean;
  [x: string]: any;
}

export function ButtonListField(props: ButtonListFieldProps) {
  const { id, options, onClick, name, btnType, isDisabled, ...rest } = props;
  return (
    <HStack
      flexWrap="wrap"
      gap={5}
      maxW={{ lg: options.length > 4 ? '85%' : '75%' }}
      justifyContent="center"
      flexDir="row"
    >
      <Field name={name}>
        {({ form: { setFieldValue } }: FieldProps) =>
          options.map((option) => (
            <Button
              key={option.value}
              size="2xl"
              type={btnType || 'button'}
              variant="outlinePrimary"
              whiteSpace="break-spaces"
              isDisabled={isDisabled}
              onClick={() => {
                setFieldValue(name, option.value);
                onClick;
              }}
            >
              {option.label}
            </Button>
          ))
        }
      </Field>
    </HStack>
  );
}
